import script from "./DesiredView.vue?vue&type=script&lang=ts&setup=true"
export * from "./DesiredView.vue?vue&type=script&lang=ts&setup=true"

import "./DesiredView.vue?vue&type=style&index=0&id=f3b86adc&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/jobs/MASSMEDIAN_MYPAGE_VIEW_PROD/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f3b86adc"]])

export default __exports__